export default "__VITE_PUBLIC_ASSET__ca92145c__"